import { render, staticRenderFns } from "./DefaultLayoutV3New.vue?vue&type=template&id=6f9c4b29"
import script from "./DefaultLayoutV3New.vue?vue&type=script&lang=ts"
export * from "./DefaultLayoutV3New.vue?vue&type=script&lang=ts"
import style0 from "./DefaultLayoutV3New.vue?vue&type=style&index=0&id=6f9c4b29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports